import { LiveAnnounce } from "@jetblue/kit/live-announce";
import { VisuallyHidden } from "@jetblue/kit/visually-hidden";
import {
  formatCurrency,
  formatPoints,
  formatTax,
} from "../components/best-fares/format-price";
import type { SelectedToolbarPrice } from "./toolbar-price";

type BestFaresToolbarProperties = {
  announcement?: string;
  message?: string;
  selectedPrice?: SelectedToolbarPrice;
};

const FOOTER_TRIP_LABELS: Record<SelectedToolbarPrice["tripType"], string> = {
  "one-way": "one-way/person",
  "round-trip": "roundtrip/person",
};

const getTripLabel = (tripType: SelectedToolbarPrice["tripType"]) =>
  FOOTER_TRIP_LABELS[tripType];

export const BestFaresToolbar = ({
  announcement,
  message,
  selectedPrice,
}: BestFaresToolbarProperties) => {
  if (!message && !selectedPrice) {
    return null;
  }

  let selectedPriceSlot = null;

  if (selectedPrice) {
    const { amount, currencyCode, tax, tripType, usePoints } = selectedPrice;

    selectedPriceSlot = (
      <div className="min-w-0 pe-3 text-end leading-tight">
        <div className="text-s-body font-bold text-core-blue">
          {usePoints ? (
            <>
              <span>{formatPoints(amount)} pts</span>
              {tax ? <span> + {formatTax(tax, currencyCode)}</span> : null}
            </>
          ) : (
            formatCurrency(amount, currencyCode)
          )}
        </div>
        <div className="text-s-body text-charcoal">
          {getTripLabel(tripType)}
        </div>
      </div>
    );
  }

  return (
    <>
      <LiveAnnounce as={VisuallyHidden}>{announcement}</LiveAnnounce>
      <div
        className="
          grid min-w-0 flex-1 grid-cols-[minmax(0,2fr)_minmax(0,1fr)]
          items-center
        "
      >
        {message ? (
          <div
            className={
              selectedPrice
                ? `
                  hidden min-w-0 justify-self-start pe-3 text-start text-legal
                  text-charcoal

                  md:block
                `
                : `
                  min-w-0 justify-self-start pe-3 text-start text-legal
                  text-charcoal
                `
            }
          >
            {message}
          </div>
        ) : (
          <div />
        )}

        {selectedPriceSlot}
      </div>
    </>
  );
};
